module.exports = __webpack_public_path__ + "static/media/bensound-buddy.cd95474d.mp3";